import $ from 'jquery'

export default {
	name: 'assurances',
	components: {},
	props: [],
	data() {
		return {
			user_role: '',           //  Role d'un utilisateur

			fields: ['nom', { key: 'telephone', label: 'Téléphone' }, 'email', 'actions'],

			filter: "",
			tableIsBusy: true,
			perPage: 20,
			currentPage: 1,

			is_empty: false,
			is_loading: true,

			// Tel input placeholder config
            options: { placeholder: "Ex. 90 00 00 00", maxlength: 11 },
            tel_is_required: false,
			country_code: '',

			prefered_countries: [this.default_country_code],
            only_countries: ['tg', 'bj', 'ci'],

			compagnie: {
				compagnie_id: 0,
				nom: '',
				code_tel: '',
				telephone: '',
				email: '',
				adresse: '',
				is_edit: 0
			},
			save_loading: false,
			btn_disable: false,

			compagnie_to_be_deleted: [],
            del_loading: false,
            is_confirm: false,

			// Groupe assurance
			groupe_assur: '',
			groupe_assur_id: 0,
			grp_loading: true,
			grp_is_empty: false,
			groupe_to_be_deleted: [],

			grp_fields: ['groupes', {key: 'default', label: 'Base'}, 'actif', 'actions'],
			grp_per_page: 5,
			is_list_group: true,

			g_default: '',
			g_actif: ''

		}
	},

	watch: {
		g_default() {
			this.changeDefaultBase('default', this.g_default)
		},

		g_actif() {
			this.changeDefaultBase('actif', this.g_actif)
		}
	},

	computed: {
		compagnie_assurances() {
            return this.$store.getters["compagnie_assurances"];
        },

		groupe_assurs() {
            return this.$store.getters["groupe_assurs"];
        },

		rows() {
            return this.compagnie_assurances.length;
        },

		grp_rows() {
            return this.groupe_assurs.length;
        },
	},
	mounted() {
		this.$store.dispatch("getAssurance").then(() => {
			this.is_loading = false
			if(this.compagnie_assurances.length > 0) {
				this.is_empty = false
			} else {
				this.is_empty = true
			}
		});

		// Liste des groupes d'assurances
		this.getGroupeAssurance()
	},
	methods: {
		clearError() {
			for (let i = 1; i <= 3; i++) {
				$('.err-msg-'+i).fadeOut(500)
			}
		},

		changeDefaultBase(type_config, groupe_id) {
			let data = {
				type_config: type_config,
				groupe_id: groupe_id
			}

			this.$store.dispatch('configBaseActifAssurance', data)
		},

		getGroupeAssurance() {
			this.grp_loading = true
			this.$store.dispatch("getGroupeAssurance").then(() => {
				this.grp_loading = false
				if(this.groupe_assurs.length > 0) {
					this.grp_is_empty = false

					this
				} else {
					this.grp_is_empty = true
				}
			});
		},

		refreshCompagnie() {
			this.is_loading = true
			this.$store.dispatch("getAssurance").then(() => {
				this.is_loading = false
				if(this.compagnie_assurances.length > 0) {
					this.is_empty = false
				} else {
					this.is_empty = true
				}
			});
		},

		countryChanged(country) {
            this.compagnie.code_tel = '+'+country.dialCode
        },

		async submit() {
			const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.btn_disable = true

            this.$store.dispatch("addAssurance", this.compagnie).then((response) => {
                if (response > 0) {
                    this.refreshCompagnie();

					
					if (this.compagnie.is_edit == 0) {
						this.successMsg('Compagnie d\'assurance ajouté avec succès')
					} else {
						this.successMsg('Compagnie d\'assurance modifié avec succès')
					}
					$('.modal').modal('hide')
                    
                    this.compagnie = {
						compagnie_id: 0,
						nom: '',
						code_tel: '',
						telephone: '',
						email: '',
						adresse: '',
						is_edit: 0
					}
					
					
                } else {
					if (response == -1) {
						$('.err-msg-1').fadeIn(500)
					} else if (response == -2) {
						$('.err-msg-2').fadeIn(500)
					} else if (response == -3) {
						$('.err-msg-3').fadeIn(500)
					}
                }
				this.save_loading = false
                this.btn_disable = false
            })
		},

		successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

		doErrorMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                theme: 'toasted-primary',
                type: 'error'

            })
        },

		/**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		remove(data) {
			this.compagnie_to_be_deleted = {
                id: data.id,
                compagnie: data.compagnie_assurance,
            }
		},

		edit (data) {
			let phone_number = ''
			if (data.telephone != '' && data.telephone != null) {
				phone_number = data.telephone.split("+228").pop()
			} 
			
			this.compagnie = {
				compagnie_id: data.id,
				nom: data.compagnie_assurance,
				code_tel: '',
				telephone: phone_number,
				email: data.email,
				adresse: data.adresse,
				is_edit: 1
			}
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteCompagnie', this.compagnie_to_be_deleted).then((response) => {
                    console.log("DEL repsonse : ", response)
                    if (response > 0) {
                        this.successMsg('Compagnie d\'assurance supprimé avec succès')
                    }

					this.refreshCompagnie();
					$('.modal').modal('hide')
                    this.del_loading = false;
                    this.is_confirm = false
                    
                })
            }
        },

		addGroupe() {
			$('.list-group').fadeOut(500)
			setTimeout(() => {
				$('.new-group').fadeIn()
			}, 500);
			this.is_list_group = false
		},

		backToList() {
			$('.new-group').fadeOut(500)
			setTimeout(() => {
				$('.list-group').fadeIn()
			}, 500);
			this.is_list_group = true
		},

		/**
		 * Ajouter un groupe d'assurance
		 */
		async submitGroupe() {
			const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.btn_disable = true

			let data = {
				groupe_assur_id: this.groupe_assur_id,
				groupe_assur: this.groupe_assur
			}

			this.$store.dispatch('addGroupeAssurance', data).then((response) => {
				if (response.saved_id > 0) {
					// this.successMsg('Groupe d\'assurance ajouté avec succès')

					// $('.modal').modal('hide')
					this.getGroupeAssurance()
					setTimeout(() => {
						this.backToList()
					}, 500);
					
					this.groupe_assur = ''
					this.$refs.observer.reset();
				} else {
					if (response.is_exist > 0) {
						$('.err-msg-1').fadeIn(500)
					}
				}
				this.save_loading = false
				this.btn_disable = false
			})
		}, 

		editGroupe(data) {
			this.groupe_assur = data.groupe
			this.groupe_assur_id = data.groupe_id
		}, 

		removeGroupe(data) {
			this.groupe_to_be_deleted = {
                id: data.groupe_id,
                libelle: data.groupe,
            }
		},

		supprimerGroupe() {
			this.del_loading = true;

            let confirm = document.getElementById('cfrm-del-grp');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteGroupeAssurance', this.groupe_to_be_deleted).then((response) => {
                    if (response > 0) {
                        // this.successMsg('Groupe d\'assurance supprimé avec succès')
                    }

					this.getGroupeAssurance();
					$('.delete-grp').modal('hide')
                    this.del_loading = false;
                    this.is_confirm = false
                    
                })
            }
		}
	}
}


